module.exports = __webpack_public_path__ + "img/hana.3e5fc7b4.png";